import apiClient from "./apiClient";

/**
 * Admin Portal data layer — calls the platform-admin /api/v1/admin/* API.
 * Auth + headers are attached by apiClient; these endpoints act cross-org and
 * are gated server-side by require_platform_admin.
 */
const B = "/api/v1/admin";

const get = (p, params) => apiClient.get(`${B}${p}`, { params }).then((r) => r.data);
const post = (p, body, params) =>
  apiClient.post(`${B}${p}`, body || {}, { params }).then((r) => r.data);
const patch = (p, body) => apiClient.patch(`${B}${p}`, body).then((r) => r.data);

const adminApi = {
  // Tenants
  listOrganizations: (params) => get("/organizations", params),
  orgSummary: () => get("/organizations/summary"),
  createOrganization: (body) => post("/organizations", body),
  updateOrganization: (id, body) => patch(`/organizations/${id}`, body),
  suspendOrganization: (id) => post(`/organizations/${id}/suspend`),
  reactivateOrganization: (id) => post(`/organizations/${id}/reactivate`),

  // Users (cross-org)
  listUsers: (params) => get("/users", params),
  usersSummary: () => get("/users/summary"),
  createUser: (organizationId, body) => post("/users", body, { organization_id: organizationId }),
  deactivateUser: (id) => post(`/users/${id}/deactivate`),
  reactivateUser: (id) => post(`/users/${id}/reactivate`),
  sendSetupEmail: (id) => post(`/users/${id}/send-setup-email`),
  grantPlatformAdmin: (id) => post(`/users/${id}/grant-platform-admin`),
  revokePlatformAdmin: (id) => post(`/users/${id}/revoke-platform-admin`),

  // Catalog
  listProviders: (params) => get("/catalog/providers", params),
  createProvider: (body) => post("/catalog/providers", body),
  updateProvider: (id, body) => patch(`/catalog/providers/${id}`, body),
  deactivateProvider: (id) => post(`/catalog/providers/${id}/deactivate`),
  listProviderApis: (params) => get("/catalog/provider-apis", params),
  createProviderApi: (body) => post("/catalog/provider-apis", body),
  updateProviderApi: (id, body) => patch(`/catalog/provider-apis/${id}`, body),
  deactivateProviderApi: (id) => post(`/catalog/provider-apis/${id}/deactivate`),
  listEndpoints: (params) => get("/catalog/endpoints", params),
  createEndpoint: (body) => post("/catalog/endpoints", body),
  updateEndpoint: (id, body) => patch(`/catalog/endpoints/${id}`, body),
  deactivateEndpoint: (id) => post(`/catalog/endpoints/${id}/deactivate`),

  // Integrations & secrets oversight (read-only, redacted)
  listIntegrations: (params) => get("/integrations", params),

  // Observability
  usageProviders: (params) => get("/observability/usage/providers", params),
  usageProviderApis: (params) => get("/observability/usage/provider-apis", params),
  executionsSummary: (params) => get("/observability/executions/summary", params),
  executions: (params) => get("/observability/executions", params),
  agentRuns: (params) => get("/observability/agent-runs", params),
  agentRunsSummary: (params) => get("/observability/agent-runs/summary", params),
  eventsSummary: (params) => get("/observability/events/summary", params),
  eventsTopApps: (params) => get("/observability/events/top-apps", params),
  events: (params) => get("/observability/events", params),

  // Audit
  auditLog: (params) => get("/audit-log", params)
};

export default adminApi;
